<h2 mat-dialog-title class="text-lg font-bold mb-1">Documento de Transporte</h2>
<mat-dialog-content class="modal-content-monitor">
  <div class="table-container">
    <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
      <table class="w-full table-fixed mat-elevation-z" mat-table [dataSource]="dataSource" matSort
        (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
        <ng-container matColumnDef="det">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="toggleDetails(element)"
              style="margin-left: 10px">
              <mat-icon class="icon-size-5" [svgIcon]="
                      selectedOrder?._id === element._id
                        ? 'heroicons_solid:chevron-down'
                        : 'heroicons_solid:chevron-up'
                    "></mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="check">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col">
            <mat-checkbox color="primary" (change)="
                    $event ? masterToggle() : null; onCheckboxChange($event)
                  " [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col">
            <mat-checkbox color="primary" (click)="
                    $event.stopPropagation(); onCheckboxChange($event, element)
                  " (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)"
              [aria-label]="checkboxLabel(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"></th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <mat-icon *ngIf="element.statusId == StatusEnum.INACTIVE" svgIcon="heroicons_solid:x-circle" matTooltip="Anulado"
              style="color: rgb(141, 19, 19); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusId == StatusEnum.ACTIVE" [attr.aria-label]="getIconConfig(element.type.code).tooltip"
              [matTooltip]="getIconConfig(element.type.code).tooltip"
              [style.color]="getIconConfig(element.type.code).color" style="cursor: pointer" [svgIcon]="
                    getIconConfig(element.type.code).iconType === 'svg'
                      ? getIconConfig(element.type.code).icon
                      : null
                  ">
              <!-- Solo muestra texto para font icons -->
              <span *ngIf="getIconConfig(element.type.code).iconType === 'font'">
                {{ getIconConfig(element.type.code).icon }}
              </span>
            </mat-icon>
            <!-- <mat-icon
                  *ngIf="element.statusId == StatusEnum.ACTIVE"
                  svgIcon="heroicons_solid:check-circle"
                  matTooltip="Creado"
                  style="color: rgb(65, 106, 218); cursor: pointer"
                ></mat-icon> -->
            <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_IN_PROGRESS" svgIcon="heroicons_solid:play-circle"
              matTooltip="En proceso de aprobación" style="color: rgb(236, 199, 58); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_APPROVED" svgIcon="heroicons_solid:check-circle" matTooltip="Aprobado"
              style="color: rgb(9, 133, 50); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_REJECTED" svgIcon="heroicons_solid:x-circle" matTooltip="Rechazado"
              style="color: rgb(255, 0, 0); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_DELIVERED" svgIcon="mat_solid:checklist_rtl" matTooltip="Entregado completamente al cliente"
              style="color: rgb(9, 133, 50); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_PARTIAL_DELIVERED" svgIcon="mat_solid:check" matTooltip="Entregado parcialmente al cliente"
              style="color: rgb(255, 136, 0); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_DELIVERY_REJECTED" svgIcon="mat_solid:indeterminate_check_box"
              matTooltip="No entregado al cliente" style="color: rgb(255, 55, 0); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_PARTIAL_APPROVED" svgIcon="heroicons_solid:check-circle"
              matTooltip="Aprobado Parcialmente" style="color: rgb(102, 205, 170); cursor: pointer"></mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="statusERP">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"></th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING || !element.statusERP" svgIcon="heroicons_solid:clock"
              matTooltip="Pendiente envío a ERP" style="color: rgb(233, 124, 61); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_SEND" svgIcon="heroicons_solid:document-arrow-up"
              matTooltip="Enviado a ERP" style="color: rgb(65, 106, 218); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_RECEIVED" svgIcon="heroicons_solid:document-arrow-down"
              matTooltip="Recibido por ERP" style="color: rgb(236, 199, 58); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_CREATED" svgIcon="heroicons_solid:document-check" matTooltip="Creado en ERP"
              style="color: rgb(9, 133, 50); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR" svgIcon="heroicons_solid:exclamation-triangle"
              matTooltip="Error enviando a ERP" style="color: rgb(141, 19, 19); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE" svgIcon="heroicons_solid:clock"
              matTooltip="Mod. pendiente de replicar" style="color: rgb(148, 46, 139); cursor: pointer"></mat-icon>
            <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR_ERP" svgIcon="heroicons_solid:exclamation-triangle"
              matTooltip="Error en ERP" style="color: rgb(255, 0, 0); cursor: pointer"></mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"></th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <span *ngIf="element?.subApplication?.code == 'CSMOBILE-BACKOFFICE'" style="
                    background-color: rgb(40, 101, 141);
                    color: white;
                    padding: 3px 6px 3px 5px;
                    border-radius: 5px;
                    margin-left: 7px;
                    margin-right: 7px;
                    cursor: pointer;
                  " [matTooltip]="element?.subApplication?.name">
              B
            </span>
            <span *ngIf="element?.subApplication?.code == 'CSMOBILE-APP'" style="
                    background-color: rgb(218, 41, 28);
                    color: white;
                    padding: 3px 6px 3px 5px;
                    border-radius: 5px;
                    margin-left: 7px;
                    margin-right: 7px;
                    cursor: pointer;
                  " [matTooltip]="element?.subApplication?.name">
              A
            </span>
            <span *ngIf="element?.subApplication?.code == 'CSMOBILE-ERP'" style="
                    background-color: rgb(255, 123, 0);
                    color: white;
                    padding: 3px 6px 3px 5px;
                    border-radius: 5px;
                    margin-left: 7px;
                    margin-right: 7px;
                    cursor: pointer;
                  " [matTooltip]="'ERP'">
              E
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="soldTo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
            Cliente
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <p class="table-text-m" style="min-width: 102px">
              <span class="table-text-code">{{
                element.soldTo?.externalKeys?.code
                }}</span><br />
              {{ element.soldTo?.name }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="documentNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
            <span style="text-align: left">Nro. Doc.</span>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <p class="table-text-m" style="min-width: 55px">
              <span class="table-text-code">{{ element?.serial }}</span><br />
              {{ element?.externalKeys?.code }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="class">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
            Clase
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <p class="table-text-m">
              @if (element.class) {
              <span class="table-text-code" *ngIf="getCode(element.class) as code">
                {{ code }} <br />
              </span>
              }
              {{ element?.class?.name }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
            Fecha
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <p class="table-text-m" style="min-width: 130px">
              <b>C: </b> {{element?.loadDateTime | FormatDateHour: false }} <br>
              <b>E: </b> {{element?.deliveryDateTime | FormatDateHour: false }}
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="subTotal">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle text-right">
            <span class="table-text-m-2">SubTotal</span>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text text-right">
            <p class="table-text-m-2">
              {{ element?.subTotal | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="surcharge">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle text-right">
            <span class="table-text-m-2">Recargo</span>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text text-right">
            <p class="table-text-m-2">
              {{ element?.totalSurcharges | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="discount">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle text-right">
            <span class="table-text-m-2">Descuento</span>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text text-right">
            <p class="table-text-m-2">
              {{ element?.totalDiscounts | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="tax">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle text-right">
            <span class="table-text-m-2">Impuesto</span>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text text-right">
            <p class="table-text-m-2">
              {{ element?.totalTaxes | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle text-right">
            <span class="table-text-m-2">Total</span>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text text-right">
            <p class="table-text-m-2">
              {{ element?.total | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="creation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
            Creación
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            {{element?.creationDateTime | FormatDateHour: true }}
          </td>
        </ng-container>
        <ng-container matColumnDef="loadDateTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
            Carga y<br />Entrega
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <b>C: </b> {{element?.loadDateTime | FormatDateHour: false }} <br>
            <b>E: </b> {{element?.deliveryDateTime | FormatDateHour: false }}
          </td>
        </ng-container>
        <ng-container matColumnDef="documentStatus">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle text-right">
            Estado<br />Doc.
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col text-right">
            {{ "-" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col" style="min-width: 40px">
            <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Generar Documento"
              (click)="openConfirmDialog(null)" [disabled]="!isGlobalSynchronizeAvailable">
              <mat-icon svgIcon="heroicons_outline:clipboard-document-check"></mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col">
            <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu">
              <!-- <button mat-menu-item (click)="openLogModal(element)">
                <mat-icon>visibility</mat-icon>
                <span>Visualizar logs</span>
              </button> -->
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <ng-container *ngIf="selectedOrder?._id === element._id" class="details-row">
              <ng-container *ngTemplateOutlet="
                      rowDetailsTemplate;
                      context: { $implicit: row }
                    "></ng-container>
            </ng-container>
          </td>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
        <!-- Fila principal -->
        <tr mat-row *matRowDef="let element; columns: displayedColumns" class="border-b"
          [class.table-expanded-row]="selectedOrder?._id === element._id"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
      </table>
    </div>
    <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">
      Lo sentimos, no hay registros para mostrar.
    </div>
  </div>
  <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
      [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close (click)="onCancel()" class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="openConfirmDialog(null)" class="justify-end"
  [disabled]="!isGlobalSynchronizeAvailable">
    Generar
  </button>
</mat-dialog-actions>

<ng-template #rowDetailsTemplate let-order>
  <div class="overflow-hidden">
      <div class="flex border-b">
          <form class="flex w-full flex-col">
              <div class="flex flex-col py-3 px-12 sm:flex-row">
                  <div class="flex flex-auto flex-wrap">
                      <div class="grid-container table-text">
                        <div class="row">
                          <div class="cell cell-3 table-title">Destinatario:</div>
                          <div class="cell cell-4">{{selectedOrder.shipTo?.externalKeys?.code + ' - '}} {{selectedOrder.shipTo?.name}}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Dirección:</div>
                          <div class="cell cell-4">{{selectedOrder.address?.address }} {{ selectedOrder.address?.postalCode ? ' / ' + selectedOrder.address?.postalCode : ' ' }} {{ selectedOrder.address?.contactName ? ' / ' + selectedOrder.address?.contactName : ' ' }} {{ selectedOrder.address?.locationTwo?.name ? ' / ' + selectedOrder.address?.locationTwo?.name : ' ' }} {{ selectedOrder.address?.LocationThree?.name ? ' / ' + selectedOrder.address?.LocationThree?.name : ' ' }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Clase de Expedición:</div>
                          <div class="cell cell-4">{{ selectedOrder?.expeditionCondition?.externalKeys?.code }} - {{ selectedOrder?.expeditionCondition?.name}}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Condición de Pago:</div>
                          <div class="cell cell-4">{{ selectedOrder?.paymentCondition?.externalKeys?.code }} - {{ selectedOrder?.paymentCondition?.name}}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Observaciones:</div>
                          <div class="cell cell-4">{{selectedOrder?.note ?? ' - '}}</div>
                        </div>
                        <div class="row">
                          <b>Fecha de Carga: </b> {{selectedOrder?.loadDateTime | FormatDateHour: false }}<br>
                        </div>
                        <div class="row">
                          <b>Fecha de Entrega: </b> {{selectedOrder?.deliveryDateTime | FormatDateHour: false }}
                        </div>
                      </div>
                      <div class="grid-container table-text">
                        <div class="row">
                          <div class="cell cell-3 table-title">Estado Global:</div>
                          <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'GLOBAL') }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Estado de rechazo:</div>
                          <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'REJECT') }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Estado de entrega:</div>
                          <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'DELIVERY') }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Estado de crédito:</div>
                          <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'CREDIT') }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Estado de factura:</div>
                          <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'INVOICE') }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Estado de usuario:</div>
                          <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'USER') }}</div>
                        </div>
                      </div>
                      <div class="grid-container table-text">
                        <div class="row">
                          <div class="cell cell-3 table-title">SubTotal:</div>
                          <div class="cell cell-4 text-right">{{ (selectedOrder?.subTotal | decimalFormat) }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Recargo:</div>
                          <div class="cell cell-4 text-right">{{ (selectedOrder?.totalSurcharges | decimalFormat) }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Descuento:</div>
                          <div class="cell cell-4 text-right">{{ (selectedOrder?.totalDiscounts | decimalFormat) }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Impuesto:</div>
                          <div class="cell cell-4 text-right">{{ (selectedOrder?.totalTaxes | decimalFormat) }}</div>
                        </div>
                        <div class="row">
                          <div class="cell cell-3 table-title">Total:</div>
                          <div class="cell cell-4 text-right">{{ (selectedOrder?.total | decimalFormat) }}</div>
                        </div>
                      </div>
                      <div class="flex w-full flex-col">
                        <table
                          class="min-w-500 overflow-y-visible mat-elevation-z mt-3"
                          mat-table
                          [dataSource]="dataSourceDetail"
                          matSort
                        >
                          <ng-container matColumnDef="material">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              class="px-6 text-left first-col table-tittle"
                            >
                              <span style="margin-left: 5px">Material</span>
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 text-left first-col table-text"
                            >
                              <p class="table-text-m">
                                <span
                                  class="table-text-code"
                                  *ngIf="getCode(detail.material) as code"
                                  [style.textDecoration]="
                                    detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                                  "
                                  [style.textDecorationColor]="
                                    detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                                  "
                                >
                                  {{ code }}
                                </span>
                                <span *ngIf="detail.statusId == StatusEnum.INACTIVE" style="color: red"
                                  ><b> (Eliminado)</b></span
                                ><br />
                                <span
                                  [style.textDecoration]="
                                    detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                                  "
                                  [style.textDecorationColor]="
                                    detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                                  "
                                >
                                  {{ detail.material?.name }}
                                </span>
                              </p>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="note">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              class="px-6 text-left first-col table-tittle"
                            >
                              Nota
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 text-left first-col table-text"
                            >
                              <button
                                mat-icon-button
                                color="primary"
                                matTooltip="{{ detail.note }}"
                                [disabled]="!(detail.note && detail.note != '')"
                              >
                                <mat-icon
                                  svgIcon="heroicons_outline:chat-bubble-bottom-center-text"
                                ></mat-icon>
                              </button>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="warehouse">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              class="px-6 text-left first-col table-tittle"
                            >
                              Almacén
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 text-left first-col table-text"
                            >
                              <p *ngIf="!detail.isEditMode" class="table-text-m">
                                <span
                                  class="table-text-code"
                                  *ngIf="getCode(detail.warehouse) as code"
                                >
                                  {{ code }} <br />
                                </span>
                                {{ detail.warehouse?.name }}
                              </p>
                              <mat-form-field
                                *ngIf="detail.isEditMode"
                                class="mt-2 w-full"
                                appearance="fill"
                                floatLabel="never"
                              >
                                <mat-select
                                  [(ngModel)]="detail.warehouse"
                                  placeholder="Almacén"
                                  matTooltip="{{ detail.warehouse?.name }}"
                                  [ngModelOptions]="{ standalone: true }"
                                  [compareWith]="compareById"
                                  (selectionChange)="
                                    detail.thereIsChanges = true;
                                    onChangeWarehouseInOrderDetail(detail)
                                  "
                                >
                                  @for (
                                    warehouse of selectedOrder.warehousesToUpdate || [];
                                    track warehouse
                                  ) {
                                    <mat-option [value]="warehouse" class="text-content">
                                      {{ warehouse.externalKeys?.code + " - "
                                      }}{{ warehouse.name }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="soldQuantity">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              class="text-left first-col table-tittle"
                            >
                              <span class="table-text-m-2 pd-l">Cantidad</span>
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="text-left first-col table-text"
                            >
                              <div class="flex items-center justify-between">
                                <div>
                                  <p class="table-text-m-2 pd-l">
                                    {{ detail?.soldQuantity | number: "1.3" }} ({{
                                      detail?.soldUnitOfMeasure?.name
                                    }}) <br />
                                    <app-unit-measure-display
                                      [baseUnit]="{
                                        quantity: detail?.baseQuantity,
                                        unitId: detail?.baseUnitOfMeasure?._id,
                                        unitName: detail?.baseUnitOfMeasure?.name,
                                        unitAbbreviation: detail?.baseUnitOfMeasure?.code
                                      }"
                                      [parallelUnit]="{
                                        quantity: detail?.pararellQuantity,
                                        unitId: detail?.pararellUnitOfMeasure?._id,
                                        unitName: detail?.pararellUnitOfMeasure?.name,
                                        unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                                      }"
                                      [material]="{
                                        _id: detail?.material?._id,
                                        code: detail?.material?.code,
                                        UMPActive: detail?.material?.UMPActive
                                      }"
                                      [companyUMPActive]="UMPActive"
                                      [statusId]="detail.statusId"
                                    ></app-unit-measure-display>
                                  </p>
                                </div>
                                <span class="flex shrink-0 items-center gap-1">
                                <button
                                  *ngIf="hasBatches(detail)"
                                  mat-icon-button
                                  color="primary"
                                  (click)="openBatchesDetail(selectedOrder, detail)"
                                  matTooltip="Ver lotes"
                                >
                                  <mat-icon
                                    aria-hidden="false"
                                    aria-label="Example home icon"
                                    fontIcon="science"
                                  ></mat-icon>
                                </button>
                                <app-manual-label-selection-indicator
                                  [manuallySelected]="detail.deliveryLabelsManuallySelect === true"
                                ></app-manual-label-selection-indicator>
                                </span>
                              </div>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="unitPrice">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              class="px-6 first-col table-tittle text-center"
                            >
                              Precio
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 first-col table-text text-center"
                            >
                              @if (
                                detail.isEditMode &&
                                selectedOrder.class.canUpdatePrices == true
                              ) {
                                <mat-form-field
                                  class="mt-2"
                                  appearance="fill"
                                  floatLabel="never"
                                >
                                  <input
                                    matInput
                                    type="number"
                                    [(ngModel)]="detail.unitPrice"
                                    placeholder="Precio"
                                    [ngModelOptions]="{ standalone: true }"
                                    aria-label="Precio"
                                    matInput
                                    (change)="
                                      onChangePriceInOrderDetail(selectedOrder, detail)
                                    "
                                    (keyup)="
                                      onChangePriceInOrderDetail(selectedOrder, detail)
                                    "
                                  />
                                </mat-form-field>
                              } @else {
                                <span
                                  [style.textDecoration]="
                                    detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                                  "
                                  [style.textDecorationColor]="
                                    detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                                  "
                                >
                                  {{ detail?.unitPrice | decimalFormat }}
                                </span>
                              }
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="subTotal">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              arrowPosition="before"
                              class="px-6 text-left first-col table-tittle"
                            >
                              SubTotal
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 text-left first-col table-text text-right"
                            >
                              <span
                                [style.textDecoration]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                                "
                                [style.textDecorationColor]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                                "
                              >
                                {{ detail?.subTotal | decimalFormat }}
                              </span>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="totalSurcharges">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              arrowPosition="before"
                              class="px-6 text-left first-col table-tittle"
                            >
                              Recargo
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 first-col table-text text-right"
                            >
                              <span
                                [style.textDecoration]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                                "
                                [style.textDecorationColor]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                                "
                              >
                                {{ detail?.totalSurcharges | decimalFormat }}
                              </span>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="totalDiscounts">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              arrowPosition="before"
                              class="px-6 text-left first-col table-tittle"
                            >
                              Descuento
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 irst-col table-text text-right"
                            >
                              <span
                                [style.textDecoration]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                                "
                                [style.textDecorationColor]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                                "
                              >
                                {{ detail?.totalDiscounts | decimalFormat }}
                              </span>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="tax">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              arrowPosition="before"
                              class="px-6 text-left first-col table-tittle"
                            >
                              Impuesto
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 first-col table-text text-right"
                            >
                              <span
                                [style.textDecoration]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                                "
                                [style.textDecorationColor]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                                "
                              >
                                {{ detail?.totalTaxes | decimalFormat }}
                              </span>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="total">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              arrowPosition="before"
                              class="px-6 text-left first-col table-tittle"
                            >
                              Total
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 first-col table-text text-right"
                            >
                              <span
                                [style.textDecoration]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                                "
                                [style.textDecorationColor]="
                                  detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                                "
                              >
                                {{ detail?.total | decimalFormat }}
                              </span>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="actions">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              class="px-6 first-col table-tittle text-center"
                            ></th>
          
                            <!--
                           
                              <button
                                *ngIf="validateDataToEdit(selectedOrder)"
                                mat-icon-button
                                color="primary"
                                (click)="onAddOrderDetail(selectedOrder)"
                                matTooltip="Agregar detalle"
                              >
                                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                              </button>
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 first-col table-text text-center"
                            >
                              <div
                                *ngIf="
                                  detail.statusId != StatusEnum.INACTIVE && validateDataToEdit(selectedOrder)
                                "
                              >
                                <button
                                  *ngIf="!detail.isEditMode"
                                  color="primary"
                                  mat-icon-button
                                  (click)="detail.isEditMode = true"
                                  matTooltip="Editar"
                                >
                                  <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                                </button>
                                <button
                                  *ngIf="detail.isEditMode"
                                  color="primary"
                                  mat-icon-button
                                  (click)="
                                    openOrderDetailUpdateConfirmation(selectedOrder, detail)
                                  "
                                  matTooltip="Guardar"
                                >
                                  <mat-icon svgIcon="heroicons_outline:check"></mat-icon>
                                </button>
                                <button
                                  color="warn"
                                  mat-icon-button
                                  (click)="onCancelOrder(selectedOrder, detail)"
                                  matTooltip="Eliminar"
                                >
                                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                </button>
                              </div>
                              <div *ngIf="detail.statusId == StatusEnum.INACTIVE">
                                <button
                                  mat-icon-button
                                  color="warn"
                                  matTooltip="{{ detail.reasonForRejection }}"
                                  [disabled]="
                                    !(
                                      detail.reasonForRejection &&
                                      detail.reasonForRejection != ''
                                    )
                                  "
                                >
                                  <mat-icon
                                    svgIcon="heroicons_outline:chat-bubble-bottom-center-text"
                                  ></mat-icon>
                                </button>
                              </div>
                              -->
          
                            <td
                              mat-cell
                              *matCellDef="let detail"
                              class="px-6 first-col table-text text-center"
                            >
                              <button
                                *ngIf="validateDataToEdit(selectedOrder)"
                                mat-icon-button
                                [matMenuTriggerFor]="actionMenuDetails"
                                matTooltip="Acciones"
                              >
                                <mat-icon>more_vert</mat-icon>
                              </button>
                              <mat-menu #actionMenuDetails="matMenu">
                                <button
                                  mat-menu-item
                                  color="primary"
                                  (click)="onOpenModalEditOrderDetail(detail)"
                                  matTooltip="Agregar detalle"
                                >
                                  <mat-icon
                                    svgIcon="heroicons_outline:pencil-square"
                                  ></mat-icon>
                                  Editar
                                </button>
                              </mat-menu>
                            </td>
                          </ng-container>
          
                          <!-- Header Row -->
                          <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumnsDetail"
                            class="bg-gray-100 dark:bg-gray-900"
                          ></tr>
                          <!-- Fila principal -->
                          <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumnsDetail"
                            class="border-b"
                          ></tr>
                        </table>
                      </div>
                  </div>
              </div>
          </form>
      </div>
  </div>
</ng-template>

<!-- Modal Eliminar -->
<ng-template #confirmDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-blue-500 ml-4 mt-6"
        style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Confirmar documento
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea generar este documento de transporte?</p>
      </mat-dialog-content>
    </div>
  </div>
  <div class="px-4">
    <mat-form-field appearance="fill" class="w-full">
      <mat-label class="block text-gray-700">Clase de Documento</mat-label>
      <mat-select [(ngModel)]="currentCreateDocument.documentClassId">
        <mat-option>
          <ngx-mat-select-search  [(ngModel)]="searchEmissionPoint"
              (ngModelChange)="changueOptionsDocumentClass($event)"
              placeholderLabel="Buscar..."
              noEntriesFoundLabel="No se encontraron resultados">
          </ngx-mat-select-search>
        </mat-option>
        @for (documentClass of listFilterdocumentClassList; track documentClass) {
        <mat-option [value]="documentClass._id">
          {{ documentClass.name }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">
      Cancelar
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true"
    [disabled]="currentCreateDocument.documentClassId == null">
      Generar
    </button>
  </mat-dialog-actions>
</ng-template>